/* Image Media video modal controller
 * - Click on .image-media__video-trigger opens #videoModal
 * - Injects iframe HTML from section data attribute; destroys on close
 */

(function(){

	function qs(sel, root){ return (root||document).querySelector(sel); }
	function qsa(sel, root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }

		// Note: We do not build iframes here. The server provides ready-to-insert HTML via data attribute on the section

	function openModal(){
		var el = qs('#videoModal');
		if(!el) return;
		// Prefer Bootstrap 5
		if (window.bootstrap && window.bootstrap.Modal) {
			var inst = window.bootstrap.Modal.getOrCreateInstance(el, { backdrop: true });
			inst.show();
			return;
		}
		// Bootstrap 4 via jQuery
		if (window.jQuery && jQuery.fn && jQuery.fn.modal) {
			jQuery(el).modal('show');
			return;
		}
		// Fallback: simple class toggle
		el.classList.add('show'); el.style.display = 'block';
	}

	function closeModal(){
		var el = qs('#videoModal');
		if(!el) return;
		if (window.bootstrap && window.bootstrap.Modal) {
			var inst = window.bootstrap.Modal.getInstance(el) || new window.bootstrap.Modal(el);
			inst.hide();
			return;
		}
		if (window.jQuery && jQuery.fn && jQuery.fn.modal) {
			jQuery(el).modal('hide');
			return;
		}
		el.classList.remove('show'); el.style.display = 'none';
	}

	function ensureModal(){
		var el = qs('#videoModal');
		if (el) return el;
		el = document.createElement('div');
		el.id = 'videoModal';
		el.className = 'modal video-modal fade';
		el.setAttribute('tabindex', '-1');
		el.setAttribute('role', 'dialog');
		el.setAttribute('aria-hidden', 'true');
		el.innerHTML = ''
			+ '<div class="modal-dialog modal-dialog-centered col-md-10" role="document">'
			+   '<div class="modal-content">'
			+     '<button type="button" class="video-modal__close close button button--secondary-dark" data-dismiss="modal" aria-label="Close">'
			+       '<span class="video-modal__close-icon" aria-hidden="true">'
			+         '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">'
			+           '<rect width="24" height="24" opacity="0"/>'
			+           '<path d="M8,17V10H1A1,1,0,1,1,1,8H8V1a1,1,0,1,1,2,0V8h7a1,1,0,0,1,0,2H10v7a1,1,0,0,1-2,0Z" transform="translate(3 3)"/>'
			+         '</svg>'
			+       '</span>'
			+     '</button>'
			+     '<div class="video-modal__player embed-responsive embed-responsive-16by9" id="js-video-modal-player"></div>'
			+   '</div>'
			+ '</div>';
		document.body.appendChild(el);

		el.addEventListener('hidden.bs.modal', clearPlayer);
		el.addEventListener('hide.bs.modal', clearPlayer);

		var closeBtn = qs('#videoModal .video-modal__close');
		if (closeBtn) {
			closeBtn.addEventListener('click', function(){ closeModal(); setTimeout(clearPlayer, 0); });
		}
		return el;
	}

		function clearPlayer(){
		var tgt = qs('#js-video-modal-player');
		if (tgt) { tgt.innerHTML = ''; }
	}

	function injectPlayer(src){
			// Deprecated path: kept for backwards compatibility if data-video-src is ever used again
			var tgt = qs('#js-video-modal-player');
			if (!tgt) return;
			tgt.innerHTML = '';
			tgt.textContent = '';
	}

	function handleTriggerClick(e){
		e.preventDefault();
		var el = e.currentTarget;
			var section = el.closest('.image-media');
			ensureModal();
			var b64 = section && section.getAttribute('data-video-iframe');
			var tgt = qs('#js-video-modal-player');
			if (!b64 || !tgt) return;
			var html = '';
			try { html = window.atob(b64); } catch(e) { html = ''; }
			if (!html) return;
			tgt.innerHTML = html; // Insert server-rendered iframe HTML
		openModal();
	}

	function handleTriggerKey(e){
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			handleTriggerClick(e);
		}
	}

	function bind(){
		qsa('.image-media__video-trigger').forEach(function(el){
			el.addEventListener('click', handleTriggerClick);
			el.addEventListener('keydown', handleTriggerKey);
		});

		// Clear on modal hide for both BS5 and BS4
		var modalEl = qs('#videoModal');
		if (modalEl) {
			modalEl.addEventListener('hidden.bs.modal', clearPlayer);
			modalEl.addEventListener('hide.bs.modal', clearPlayer);
		}

		// Close button fallback
		var closeBtn = qs('#videoModal .video-modal__close');
		if (closeBtn) {
			closeBtn.addEventListener('click', function(){ setTimeout(clearPlayer, 0); });
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', bind);
	} else {
		bind();
	}
})();
